import { apiBaseUrl } from 'app/src/msw/shopping/api/apiBaseUrl'
import { creditCollection } from 'app/src/msw/shopping/initialSeed/credit'
import type { shoppingApi } from 'app/src/services/welfareportal'
import type { CreditGetResult } from 'app/src/services/welfareportal/shopping-api'
import { http, HttpResponse } from 'msw'

export const getCredit = http.get<object, object, shoppingApi.CreditGetResult>(apiBaseUrl + '/credit', async () => {
  const activeMembership = JSON.parse(sessionStorage.getItem('selectedCampaign') || '{}')
  console.log('MSW: getCredit for membership', activeMembership)
  const credit: CreditGetResult = await creditCollection.findFirst((q) =>
    q.where({ membershipId: activeMembership?.membershipId }),
  )!
  return HttpResponse.json(credit)
})
